import { all } from 'redux-saga/effects';

import { authSaga } from './auth';
import { billsSaga } from './bills';
import { entitiesSagas as confSaga } from './conf';
import { entitiesSagas } from './entities';
import { entitiesSagas as formsSaga } from './forms';
import { hotelAdminSagas } from './hotelAdmin';
import { hotelsSaga } from './hotels';
import { entitiesSagas as navigationSagas } from './navigation';
import { picturesSaga } from './pictures';
import { tagsSaga } from './tags';

export function* sagas() {
  yield all([
    navigationSagas(),
    entitiesSagas(),
    hotelsSaga(),
    formsSaga(),
    hotelAdminSagas(),
    authSaga(),
    billsSaga(),
    picturesSaga(),
    confSaga(),
    tagsSaga(),
  ]);
}
